// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["npm.vee-validate","npm.vuetify","npm.vue","npm.moment","npm.reka-ui","npm.vueuse","npm.zod","npm.intlify","npm.vue-i18n","npm.vue-router","npm.tailwind-merge","npm.internationalized","npm.xlsx"], () => (__webpack_require__("./pages/EndataAuth/Account/App/app.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
